import { toCamelCase } from '@cli-utils/text.js'
export function createLifecycleHookImportName(hookId: string): string {
  return `${toCamelCase(hookId)}LifecycleHook`
}
